<template>
  <div class="relative flex flex-col items-center bg-white shadow-lg rounded-xl p-4 overflow-hidden flex-1 w-full">
    <div class="absolute top-0 left-0 w-full h-1/3 bg-gradient-to-b from-[#424c42] via-[#bbc1a9] to-white"></div>
    <div class="relative flex flex-col items-center w-full space-y-3 flex-1">                  
      <!-- País -->
      <span class="text-xs font-semibold text-white px-2 py-0 rounded-full uppercase">
        {{ itemMeeting.empresa.pais.descripcion }}
      </span>
      <!-- Logo -->
      <img v-if="itemMeeting.empresa.previewLogo" :src="itemMeeting.empresa.previewLogo"
        class="w-28 h-28 object-scale-down rounded-full border-2 border-white shadow-md" />
      <div v-else
        class="w-28 h-28 object-cover rounded-full border-2 border-white shadow-md flex items-center justify-center font-semibold text-3xl text-gray-700 bg-[radial-gradient(circle,_white_0%,_#d1d5db_100%)]">
        <span class="leading-none text-gray-500 mb-1 text-xl">
          {{ iniciales(itemMeeting.empresa.nombreFantasia, '') }}
        </span>
      </div>
      <!-- Datos de la empresa -->
      <div class="space-y-0 pt-1">
        <h3 class="text-base font-bold text-gray-800 text-center line-clamp-1">{{ itemMeeting.empresa.nombreFantasia }}</h3>
        <p class="text-sm text-gray-500 text-center">{{ itemMeeting.empresa.provincia || 'N/A' }}</p>
        <p class="text-xs text-gray-400 text-center">{{ itemMeeting.empresa.pabellon ? "Pabellón " + itemMeeting.empresa.pabellon : '&nbsp;' }}</p>
        <p class="text-xs text-gray-400 text-center">{{ itemMeeting.empresa.stand ? "Stand : " + itemMeeting.empresa.stand : '&nbsp;' }}</p>
      </div>

      <!-- Avatars de acreditados -->
      <div class="flex items-center -space-x-3" >
        <template v-for="i in itemMeeting.cantidadAcreditados" :key="i">    
          <img  v-if="itemMeeting.images[i - 1]"  :src="itemMeeting.images[i - 1]" class="w-8 h-8 rounded-full border border-[#bbc1a9] object-cover bg-white"/>
          <div v-else class="w-8 h-8 rounded-full border border-[#bbc1a9] bg-gray-300"></div>
        </template>
        <template v-if="itemMeeting.cantidadAcreditados == 0">
          <div class="w-8 h-8 rounded-full border border-[#bbc1a9] bg-gray-300"></div>
        </template>
      </div>
      <div class="flex items-center text-xs text-gray-400 !mt-0">
        {{ itemMeeting.cantidadAcreditados }} acreditado/s
      </div>

      <div class="flex items-center" >
        <button @click="mostrarDetalleEmpresa" class="text-[#424c42] text-xs inline-block origin-center transition hover:text-gray-600 hover:scale-110 cursor-pointer">
          <font-awesome-icon :icon="['fas', 'fa-circle-plus']"  /> INFO
        </button>
      </div>

      <button :disabled="!permiteSolicitarReuniones" 
        v-tooltip.top="!permiteSolicitarReuniones ? 'No tiene permisos para solicitar reuniones. Solo puede aceptar solicitudes' : null"
        @click="solicitarReunion" 
        class="w-full !mt-auto cursor-pointer text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-lg transform transition-transform duration-200 hover:scale-[102%] disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:border-gray-300 disabled:text-gray-400">
        {{ $t('boton.solicitar.reunion') }}
      </button>

    </div>
  </div> 

  <DetalleEmpresaView v-if="detalleEmpresaVisible" :empresa="itemMeeting.empresa" :closeFunction="cerrarDetalleEmpresa" />

</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ItemMeeting } from 'qreventos-suite/src/services/suite.interfaces';
import DetalleEmpresaView from '@/components/views/private/modal/DetalleEmpresaView.vue';

export default defineComponent({
  components: {
    DetalleEmpresaView
  },
  props: {
    onSolicitarReunion: {
      type: Function,
      required: false
    },
    itemMeeting: {
      type: {} as PropType<ItemMeeting>,
      required: true
    },
    permiteSolicitarReuniones: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      detalleEmpresaVisible: false
    };
  },
  methods: {
    iniciales(nombre: string, apellido: string): string {
      const n = nombre?.charAt(0) || '';
      const a = apellido?.charAt(0) || '';
      return (n + a).toUpperCase();
    },
    mostrarDetalleEmpresa() {
      this.detalleEmpresaVisible = true;
    },
    cerrarDetalleEmpresa() {
      this.detalleEmpresaVisible = false;
    },
    solicitarReunion() {
      if(this.onSolicitarReunion) {
        this.onSolicitarReunion(this.itemMeeting);
      }
    },    
  }
});
</script>